import { SingletonSharedData } from '../../js/singletonSharedData';
import { SOFTPHONES_KEY, STATE_TO_PLAY_END_AUDIO } from '../../constants'
var sharedData = new SingletonSharedData();
const senderType = 2;
var timeStampSession = '';

export function messageLogin(timeStamp) {
    try {
        timeStampSession = timeStamp;
    } catch (error) {
        console.warn(error);
    }

    let isRemote = sharedData.getSoftPhone() === SOFTPHONES_KEY.MIZUJS ? 0 : 1;
    let myStorage = window.localStorage;
    let lastAgentTimeSpam = myStorage.getItem('AgentTimeSpam');

    return {
        action: 'login',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        ext: sharedData.getParameters().Extension,
        computer: sharedData.getParameters().ClientComp,
        Timestamp: timeStamp,
        Sender: senderType,
        remote: isRemote,
        LastNotReadyID: sharedData.getParameters().LastNotREADY,
        Ip: sharedData.getIPAddress(),
        LastAgentTimeSpam: lastAgentTimeSpam,
        DialingMode: sharedData.getUserData().DialingMode
    };
}

export function messageLogOut(timeStamp) {
    const obj = {
        action: 'Logout',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Timestamp: timeStamp
    };
    return JSON.stringify(obj);
}

export function messageKeepAlive(username = null, timeSpam = null) {
    return {
        keepAlive: 1,
        action: 'KeepAlive',
        Sender: senderType,
        username: username,
        timeSpam: timeSpam
    };
}

export function messageNoAvailable(userName, userID, notReadyID, conversationID,timeInPreview) {
    const obj = {
        action: 'notReady',
        username: userName,
        userID: userID,
        notReadyId: notReadyID,
        conversationID: conversationID != null ? conversationID : undefined,
        Sender: senderType,
        TimePreview: timeInPreview
    };
    return JSON.stringify(obj);
}

export function messageAgentRedy() {
    const obj = {
        action: 'ready',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Sender: senderType
    };
    return JSON.stringify(obj);
}

export function messageFirstCall(username, userID) {
    return {
        action: 'firstCall',
        username: username,
        userID: userID,
        Sender: senderType
    };
}

export function messageRetryFirstCall(username, userID) {
    const obj = {
        action: 'reconnect',
        username: username,
        userID: userID,
        Sender: senderType
    };
    return JSON.stringify(obj);
}

export function messagePassToReady(password, supervisorPassword, requieredSupervisorPass) {
    const obj = {
        nombre: sharedData.getUserData().Login,
        password: password,
        supervisorPassword: supervisorPassword,
        supervisorPasswordRequired: requieredSupervisorPass,
        ipAddress: sharedData.getParameters().ClientComp,
        Sender: senderType
    };
    return obj;
}

export function messageToSupervisor(message, admin) {
    const obj = {
        action: 'chatMessageAdmin',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        message: message,
        admin: admin,
        Sender: senderType
    };
    return JSON.stringify(obj);
}

export function messageNotifyAlreadyWrapUp() {
    const obj = {
        action: 'WrapUp',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID
    };
    return JSON.stringify(obj);
}

export function messageChangeStateHelper() {
    const obj = {
        action: 'ChangeState',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID
    };
    return JSON.stringify(obj);
}

export function messageStartStopRecording(isStop, callOutId=0) {
    const obj = {
        action: 'StartStopRecording',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        isStop: isStop,
        callOutId: callOutId
    };
    return JSON.stringify(obj);
}

export function messageSaveMarksSM(marks,callOutId) {
    const obj = {
        action: 'markCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Times: marks,
        callOutId: callOutId
    };
    return JSON.stringify(obj);
}

export function messageApiRequest(subaction, json, expectsResponse = false, callOutId=0) {
    return {
        action: 'Api',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        Json: JSON.stringify(json),
        ExpectsReponse: expectsResponse,
        callOutId: callOutId
    };
}

export function messageHangUp(subaction,callOutId,maxTime) {
    sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
    return {
        action: 'HangUp',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        callOutId: callOutId,
        calloutMaxTime:maxTime
    };
}
export function messageTransferCall(data) {
    sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
    return {
        action: 'TransferCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        acdID: data.acdID,
        callKey: data.callKey,
        datos: data.array,
        typeTransfer: data.typeTransfer,
        camId: data.camId,
        sPhone: data.sPhone,
        dnis: data.dnis,
        extId: data.extId
    };
}
export function messageAssistedTransferCall(action,data) {
    const obj = {
        action,
        username: sharedData.getUserData().Login,
        reference: data.reference,
        phoneNumber: data.sPhone,
        callId: data.callId,
        typeTransfer: data.typeTransfer !== undefined ? data.typeTransfer : '-1',
        ...(action === "TransferPreviewCall" && {subaction : 'PreviewCallTransfer'}),
        ...(data.agentDest && {agentDest : data.agentDest})
    };
    return JSON.stringify(obj);
}

export function updateInfoCall(callKey,camId, dataCall, callOutId) {
    const obj = {
        action: 'UpdateDataCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Data: dataCall,
        callKey: callKey,
        camID: camId,
        CallOutId: callOutId
    };
    return JSON.stringify(obj);
}

export function manualCall(data) {
    const obj = {
        action: 'manualCall',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        CamId: data.CamId,
        CallKey: data.CallKey,
        Phone: data.Phone,
        Data: data.Data,
        ExistsCallout: data.ExistsCallout,
        CallMode: data.CallMode,
        integration: data.integration,
        Odbc: data.Odbc,
        Ani: data.ani
    };
    return JSON.stringify(obj);
}

export function manualMessage(data) {
    const obj = {
        action: 'manualMessage',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        CamId: data.CamId,
        Phone: data.Phone,
        Message: data.Message
    };
    return JSON.stringify(obj);
}

export function messageOngoingCallIvr(id) {
    const obj = {
        action: 'OngoingCallIvr',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        id: id
    };
    return JSON.stringify(obj);
}

export function endConversationChat(data) {
	const obj = {
		action: 'responseMedia',
		username: sharedData.getUserData().Login,
		userID: sharedData.getParameters().UserID,
		Timestamp: timeStampSession,
		MediaType: data.MediaType > 3 ? data.MediaType : 1,
		ConversationId: data.ConversationId,
		MessageId: 0,
		AcdId: data.AcdId,
		isFinished: data.isReassigned? false : true,
		MessageText: '',
		Subject: '',
		SenderName: '',
		Addresses: { From: '', To: [''], CC: [''], BCC: [''] },
		FileList: ['', ''],
		showCalifWnd:data.ShowWrapUp,
        isReassigned: data.isReassigned ? true : false,
        isSendDouble: data.isSendDouble,
        IsReassignedByAgent: data.IsReassignedByAgent,
        CampType: data.CampType
	};
	return JSON.stringify(obj);
}

export function sendDisposition(data) {
    const obj = {
        action: 'endResponseMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Timestamp: timeStampSession,
        MediaType: data.type,
        DispositionID: data.disposition,
        SubDispositionID: data.subDisposition,
        ConversationId: data.conversationId,
        MessageId: data.messageId ? data.messageId : 0,
        TWrapUp: data.wrapUp,
        AcdId: data.acdId,
        ExitWrapUpDisposition: data.closeModal,
        CampType: data.camptype != null ? data.camptype : 0
    };
    return JSON.stringify(obj);
}

export function spamConversation(data) {
    const obj = {
        action: 'spamMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        Timestamp: timeStampSession,
        MediaType: data.mediaType,
        ConversationId: data.conversationId,
        MessageId: data.messageId,
        AcdId: data.acdID,
        SubAction: data.mediaType === 5 ? 'WhatsAppSpam' : null,
        CampType: data.campType
    };
    return JSON.stringify(obj);
}

export function unassignConversation(data) {
    const obj = {
        action: 'unAssignMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        Timestamp: timeStampSession,
        MediaType: data.mediaType,
        ConversationId: data.conversationId,
        MessageId: data.messageId,
        AcdId: data.acdID,
        CampType: data.campType
    };
    return JSON.stringify(obj);
}

export function discardConversation(data) {
    const obj = {
        action: 'discardMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        Timestamp: timeStampSession,
        MediaType: data.mediaType,
        ConversationId: data.conversationId,
        MessageId: data.messageId,
        AcdId: data.acdID,
        CampType: data.campType
    };
    return JSON.stringify(obj);
}

export function selectedMessage(data) {
    const obj = {
        action: 'selectedMessage',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        TimeStamp: timeStampSession,
        MediaType: data.mediaType,
        ConversationId: data.conversationId,
        MessageId: data.messageId,
        AcdId: data.acdID,
        CampType: data.campType
    };
    return JSON.stringify(obj);
}

export function RequestedLogout() {
    return {
        action: 'logout',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        conversationID: sharedData.getCurrentState() !== "DialogWhatsApp" || !sharedData.getSelectedConversationId() ? 0 : sharedData.selectedConversationId
    }
}

export const Reconnected = () => {
    return {
        action: 'Reconnected',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID
    };
};

export function sendUnifiedResponse(data) {
    if (data.attachments && data.MediaType !== 2) {
        if (data.MessageType === 'file') {
            data.MessageText = `${data.attachments.Name}>${data.attachments.Size}|${data.attachments.Url}`
        } else {
            data.MessageText = data.attachments.Url
        }
    }
    
    const obj = {
        action: 'responseMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        Timestamp: timeStampSession,
        MediaType: data.MediaType,
        ConversationId: data.ConversationId,
        MessageId: !data.messageId ||data.MediaType === 1 ? 0 : data.messageId,
        AcdId: data.AcdId,
        MessageText: data.MediaType === 1 ? data.MessageText.replaceAll('\n', '\\n').replaceAll('\r', '\\r') : data.MessageText,
        isFinished: false,
        Subject: data.subject,
        SenderName: data.senderName,
        Addresses: data.addresses,
		showCalifWnd:true,
        IsAzure: data.IsAzure,
        MessageType: data.MessageType,
        isSendDouble: false,
        CamType: data.CamType ? data.CamType : 0,
        ConvUiId: data.CamType && data.ConvUiId ? data.ConvUiId : undefined,
        CampType: data.CamType,
        ...(data.MediaType === 2 && { FileList: data.attachments })
    }
    return JSON.stringify(obj);
}
export const sendMessageToExternalMU = data => {

    const obj = {
        action: 'responseMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        Timestamp: timeStampSession,
        MediaType: data.ServiceType,
        ConversationId: data.ConversationID,
        MessageId: 0,
        AcdId: data.AcdId,
        MessageText: data.data.endConversationChat,
        isFinished: false,
        MessageType: data.Type,
        isSendDouble: false
    };
    return JSON.stringify(obj);
};

export const aceptedChat = data => {
    const obj = {
        action: 'conversationAcceptedMedia',
        username: sharedData.getUserData().Login,
        userID: sharedData.getUserData().User_id,
        Timestamp: timeStampSession,
        MediaType: data.MediaType,
        ConversationId: data.ConversationId,
        CampType: data.CampType
    }
    return JSON.stringify(obj);
}

export const acceptChatSaveTime = data => {
    const obj = {
        action: 'AcceptConversationWA',
        username: sharedData.getUserData().Login,
        ConversationId: data.ConversationId,
        CamId: data.CamId,
        CamType: data.CampType
    }
    return JSON.stringify(obj);
}

export const changeState = (data) => {
	const obj = {
		action: 'WhatsAppDialog',
		username: sharedData.getUserData().Login,
		userID: sharedData.getUserData().User_id,
		Timestamp: timeStampSession,
		ConversationId: data.ConversationId,
		Tel: data.Tel,
		CamId: data.CamiId,
		CamType: data.CamType
	};
	return JSON.stringify(obj);
}

export const changeMultimediaState = (data) => {
	const obj = {
		action: 'MultimediaDialogState',
		username: sharedData.getUserData().Login,
		userID: sharedData.getUserData().User_id,
		Timestamp: timeStampSession,
		ConversationId: data.ConversationId,
        MediaType: data.MediaType,
		ClientAccount: data.ClientAccount,
		CamId: data.CamiId,
		CamType: data.CamType,
        AllowCalls: data.AllowCalls,
        CampType: data.CampType
	};
	return JSON.stringify(obj);
}

export const closeUnified = () => {
	const obj = {
		action: 'CloseModalUnified',
		username: sharedData.getUserData().Login,
		userID: sharedData.getUserData().User_id,
		Timestamp: timeStampSession,
	};
	return JSON.stringify(obj);
}
export function SetAgentDialingMode(data) {

    const obj = {
        action: 'SetAgentDialingMode',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        active:data,
    };
    return JSON.stringify(obj);
} 

export function PreviewRecord(data) {

    const obj = {
        action: 'Preview',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        callOutId: data.callOutId,
        camId: data.camId,
        Process:data.process,
        TimePreview: data.previewTime,
        callId: data.callId,
        fMultipleJob: data.fMultipleJob || 0,
        fReplacementJob: data.fReplacementJob || 0,
        
    };
    return JSON.stringify(obj);
}

export function messagePreviewTransfer(subaction, transferAgent, callOutId) {
    const obj = {
        action: 'TransferPreviewCall',
        Subaction: subaction,
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Timestamp: timeStampSession,
        callOutId: callOutId,
        transferAgent: transferAgent,
    };
    return JSON.stringify(obj);
}

export function responsePreviewTransfer(agent, response) {
    const obj = {
        action: 'TransferPreviewCall',
        Subaction: 'AnswerAgentTransfer',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Timestamp: timeStampSession,
        mainAgent: agent,
        answerTransfer: response
    };
    return JSON.stringify(obj);
}

export function GetMoreMessages(data) {
    const obj = {
        action: 'HistoricalChats',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        MediaType: data.MediaType,
        ConversationID: data.ConversationId,
        LastConversationId: data.LastConversationId,
        CampType: data.CampType
    };
    return JSON.stringify(obj);
}

export function messageApiRequestANIList(subaction, campId, expectsResponse = false) {
    return {
        action: 'Api',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        CampId: campId, 
        ExpectsReponse: expectsResponse
    };
}
export function messageGetPreviewCampaigns(subaction) {
    const obj = {
        action: 'Campaigns',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        AgentID: sharedData.getParameters().UserID,
        Subaction: subaction,
    };
    return JSON.stringify(obj)
}

export function GetRecordCallPermission(subaction, campId, expectsResponse = false) {
    return {
        action: 'Api',
        username: sharedData.getUserData().Login,
        userID: sharedData.getParameters().UserID,
        Subaction: subaction,
        CampId: campId, 
        ExpectsReponse: expectsResponse
    };
}



// WEBPACK FOOTER //
// ./src/js/helpers/helperMessages.js